import React from 'react';
import { Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import StyledButton from '../Common/StyledButton';

const StyledGrid = styled(Grid)({
  background: 'linear-gradient(0deg, rgba(124, 174, 190, 0.2), rgba(124, 174, 190, 0.2))',
  flexDirection: 'column',
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  gap: '0.7rem',
  padding: '1.5rem 1rem 1.5rem 1rem',
});

const StyledTypography = styled(Typography)({
  '& span': {
    background: 'linear-gradient(137.65deg, #6599A5 24.11%, #3B667E 83.2%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontSize: '1.2rem',
  },
});

const AccountCreationComplete = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Grid container justifyContent="center" alignItems="center" padding="1rem">
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        borderRadius="0.6rem"
        bgcolor="white"
        border="1px solid #FFDDC8"
        sx={{
          width: {
            xs: '100%',
            sm: '90%',
            md: '25rem',
          },
          maxWidth: '100%',
        }}
      >
        <StyledGrid sx={{ borderRadius: '0.6rem 0.6rem 0 0' }}>
          <img
            src="assets/icons/confetti-blue.svg"
            alt="bin"
            role="presentation"
            style={{ height: '3rem' }}
          />
          <StyledTypography variant="title2Bold" color="primary.main">
            <span>{t('coachOnboarding.congratulations')}</span>
          </StyledTypography>
        </StyledGrid>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          gap={1}
          sx={{ padding: '2rem 2rem 2rem 2rem' }}
        >
          <Typography
            variant="bodyRegular"
            color="primary.main"
            sx={{
              fontSize: '0.9rem',
              marginBottom: { xs: '1.5rem', md: '2rem' },
            }}
          >
            {t('coachOnboarding.accountCreated')}
          </Typography>
          <StyledButton onClick={() => navigate('/')} endIcon paddingY={10}>
            {t('coachOnboarding.goToDashboard')}
          </StyledButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AccountCreationComplete;
